import { ReactNode } from "react";
import { Dialog, Modal, ModalOverlay } from "react-aria-components";
import { modalOverlay } from "../../styles/utils.css";
import { HeadingFontSize } from "../../types";
import {
  contentStyles,
  dialogWrapperStyles,
  modalStyleVariants,
} from "./sheet.css";
import SheetFooter from "./SheetFooter";
import SheetHeader from "./SheetHeader";

interface SheetProps {
  children: ReactNode;
  title?: ReactNode;
  footer?: ReactNode;
  open: boolean;
  handleClose: () => void;
  handleBack?: () => void;
  isDismissable?: boolean;
  /** Controls the width of the sheet on larger screens. */
  sizeVariant?: "small" | "large";
  headerSize?: HeadingFontSize;
}

const Sheet = ({
  title,
  children,
  footer,
  open,
  handleClose,
  handleBack,
  sizeVariant = "small",
  headerSize = "2xl",
  isDismissable = true,
}: SheetProps) => (
  <ModalOverlay
    isOpen={open}
    onOpenChange={handleClose}
    isDismissable={isDismissable}
    isKeyboardDismissDisabled={!isDismissable}
    className={modalOverlay}
  >
    <Modal className={modalStyleVariants[sizeVariant]}>
      <Dialog className={dialogWrapperStyles} aria-labelledby="sheet-title">
        <SheetHeader
          title={title}
          fontSize={headerSize}
          handleClose={handleClose}
          handleBack={handleBack}
          isDismissable={isDismissable}
        />
        <div className={contentStyles}>{children}</div>
        {footer && <SheetFooter footer={footer} />}
      </Dialog>
    </Modal>
  </ModalOverlay>
);

export default Sheet;
